import { NgModule } from "@angular/core";
import { ImportComponent } from "./import.component";
import { SpreadsheetModule } from "../s25-spreadsheet/s25.spreadsheet.module";
import { FormsModule } from "@angular/forms";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { S25ImportEventsComponent } from "./import.events.component";

@NgModule({
    declarations: [ImportComponent],
    imports: [SpreadsheetModule, FormsModule, S25DropdownPaginatedModule, S25ImportEventsComponent],
    exports: [ImportComponent],
    providers: [ImportComponent],
})
export class ImportModule {}
